import { components, InputProps } from 'react-select';
import { BaseOption } from './types';

export const SelectInput = (props: InputProps<BaseOption>) => {
  return <components.Input {...props} data-test="select-input" aria-controls="multiselect-input" />;
};
